<template>
  <div class="model-edit-form-person-availability">
    <div class="space-y-2">
      <ModelEditFormPersonAvailabilityContact
        v-for="(knownBusinessEntityContact, i) in knownBusinessEntityContactsForPerson"
        :key="knownBusinessEntityContact.id"
        v-model="knownBusinessEntityContactsForPerson[i]"
        :person="person"
      />

      <div
        v-if="knownBusinessEntityContactsForPerson.length === 0"
        class="surface rounded-md p-2 text-sm"
      >
        Geen bekende contacten beschikbaar voor deze persoon.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from "vue"
import { storeToRefs } from "pinia"
import ModelEditFormPersonAvailabilityContact from "@/components/model_edit_form/ModelEditFormPersonAvailabilityContact.vue"
import type { Person } from "@/models/person.model"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { useKnownBusinessEntitiesContactsStore } from "@/store/known-business-entities-contacts.store.ts"
import { useFormConfigurator } from "@/composables/form/form-configurator"
import type { PersonController } from "@/controllers/model-controllers/person-controller"

const personController: PersonController = inject("personController")!

const { model: person } = useFormConfigurator<Person>({
  controller: personController,
  // Looks like autoClose: false is preventing the form from closing here, so we override it.
  autoClose: true
})

const knownBusinessEntitiesContactsStore = useKnownBusinessEntitiesContactsStore()

const { knownBusinessEntitiesContacts } = storeToRefs(knownBusinessEntitiesContactsStore)

const knownBusinessEntityContactsForPerson = computed<KnownBusinessEntityContact[]>(() => {
  if (!person.value.id) {
    return knownBusinessEntitiesContacts.value.filter(
      (knownBusinessEntityContact) =>
        knownBusinessEntityContact.person === person.value ||
        knownBusinessEntityContact.person.id === person.value.id
    )
  }

  return knownBusinessEntitiesContacts.value.filter(
    (knownBusinessEntityContact) => knownBusinessEntityContact.person.id === person.value.id
  )
})
</script>

<style scoped></style>
